<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h4>Nova Permissao</h4>
			<form (keypress)="ocultarMensagem()" (ngSubmit)="f.form.valid && salvar()" #f="ngForm" name="form"
				novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="descricao">Descrição Exibição</label>
							<input type="text" pInputText
								placeholder="Insira a descrição" name="descricao" ngModel #descricao="ngModel"
								required />
							<div *ngIf="descricao.hasError('required') && descricao.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="permissao">Descrição no Banco</label>
							<input type="text" pInputText
								placeholder="Insira a descrição" name="permissao" ngModel #permissao="ngModel"
								required />
							<div *ngIf="permissao.hasError('required') && permissao.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="tipo">Tipo</label>
							<p-dropdown [options]="tipos" placeholder="Selecione"
							[filter]="true"   emptyFilterMessage="Nenhum registro"
							name="tipo" ngModel #tipo="ngModel" ></p-dropdown>
						</div>
						<div class="field col-12 md:col-6">
							<label htmlFor="categoriaPermissao">Categoria Permissao</label>
							<p-dropdown [options]="categoriasPermissoes" optionLabel="descricao" placeholder="Selecione"
							[filter]="true"   emptyFilterMessage="Nenhum registro"
							name="categoriaPermissao" ngModel #categoriaPermissao="ngModel" ></p-dropdown>
						</div>

					</div>
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
							<button type="submit" pButton icon="pi pi-check" label="Salvar"
								class="p-button-success mt-5" [disabled]="!f.valid"></button>
						</div>
						<div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
							<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Salvando..."
								class="p-button-success mt-5" [disabled]="true"></button>
						</div>
						<div class="field col-12 md:col-8">

						</div>
						<div class="field col-12 md:col-2">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-primary mt-5" routerLink="/rfarias/permissao"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>